import React from 'react';
import { useParams } from 'react-router-dom';

import Heading from 'buyside/components/presentation/ContributorDashboard/contributorDashboardHeading';
import IdeaViewsBreakdown from 'buyside/components/presentation/IdeaViewsPage/IdeaViewsBreakdown/ideaViewsBreakdown';
import IdeaViewsList from 'buyside/components/presentation/IdeaViewsPage/IdeaViewsList/ideaViewsList';
import MyIdeaPane from 'buyside/components/presentation/ContributorDashboard/ideas/myIdeaPane';
import MyIdeasNav from 'buyside/components/presentation/ContributorDashboard/ideas/myIdeasNav';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import { useLastNIdeaViewsCurrentUserQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

const MyIdeas: React.FC = () => {
  const { error, data, loading } = useLastNIdeaViewsCurrentUserQuery({ variables: { n: 10 } });

  const { ideaId } = useParams();

  if (loading)
    return (
      <>
        <Heading title="Who's viewed your ideas" />
        <LoadingSpinner size={SIZES.LARGE} />
      </>
    );
  if (error) throw error;
  if (
    !data ||
    !data.currentUser ||
    !data.currentUser.publishedIdeas ||
    !data.currentUser.publishedIdeas.edges ||
    !data.currentUser.lastNViews ||
    !data.currentUser.lastNViews.edges
  )
    return null;

  const {
    canWriteIdeas,
    lastNViews: { edges },
    publishedIdeas: { edges: ideaEdges }
  } = data.currentUser;

  const lastTenViews = edges.map(edge => edge?.node && edge.node);

  return (
    <>
      <Heading title="Who's viewed your ideas">
        {canWriteIdeas ? <SubmitResearchButton /> : null}
      </Heading>
      {ideaEdges.length ? (
        <div className={styles.ideaViewContainer}>
          <MyIdeasNav ideaId={ideaId} ideas={ideaEdges} />
          {ideaId ? (
            <MyIdeaPane ideaId={ideaId} />
          ) : (
            <div className={styles.ideaDetails}>
              {lastTenViews?.length ? (
                <>
                  <IdeaViewsList
                    views={lastTenViews.slice(0, 10)}
                    showIntroRequest={false}
                    isBig
                    fullText={false}
                  />
                  <IdeaViewsBreakdown views={lastTenViews} />
                </>
              ) : (
                <div>No idea views yet.</div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div>You do not have any submissions yet.</div>
      )}
    </>
  );
};

export default MyIdeas;
